<template>
  <div
    style="display: flex; height: 100%; "
    class="number-total"
  >
    <div
      v-for="(item, index) in numberList"
      :key="index"
      class="number-line"
      style="display: flex;"
    >
      <div v-if="isNaN(item)">
        {{ item }}
      </div>
      <div
        v-else
        class="number"
        :style="numberStyle"
      >
        <span
          ref="numberItem"
          :style="addAnimation(item, index)"
          class="number-item"
          :data-number="item"
          :data-index="index"
        >0&zwj;1234567890&zwj;12345</span>
      </div>
    </div>
  </div>
</template>

<script>
import { env } from '@hb/hbridge';

export default {
  props: {
    value: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      lastValueList: [],
    };
  },
  computed: {
    numberList() {
      return String(this.value).split('');
    },
    addAnimation() {
      return (item, index) => ({
        color: 'blue',
        animation: `move-${item}-${index} ${1.8 + index * 0.05}s ease forwards`,
      });
    },
    numberStyle() {
      return {
        marginTop: `${env.isIOS ? '0.12rem' : '0.05rem'}`,
      };
    },
    animateForward() {
      return (lastValue) => 100 * ((lastValue < 5 ? Number(lastValue) + 10 : lastValue) / 16);
    },
  },
  watch: {
    value() {
      this.$nextTick(() => {
        this.setNumberTransform();
      });
    },
  },
  mounted() {
    this.setNumberTransform();
  },
  methods: {
    // 设置每一位数字的偏移
    setNumberTransform() {
      const numberItems = this.$refs.numberItem;
      Array.from(numberItems).forEach((c) => {
        const key = c.dataset.index;
        const value = c.dataset.number;
        if (value === this.lastValueList[key]) return;
        const style = document.styleSheets[1];
        style.insertRule(`@keyframes move-${value}-${key} { 0% { transform: translateY(-${this.lastValueList[key] ? this.animateForward(this.lastValueList[key]) : 0}%); }
            100% { transform: translateY(-${this.animateForward(value)}%); }}`, 0);
        this.lastValueList[Number(key)] = value;
      });
    },
  },
};
</script>

<style scoped lang="less">
.number-total {
  margin-left: 0.25rem;
}
.number-line {
  margin-left: -0.25rem;
}
.number {
  width: 0.35rem;
  height: 0.3rem;
  overflow: hidden;

  span {
    writing-mode: vertical-lr;
    text-orientation: upright;
    transform: translateY(0%);
    line-height: 0.37rem; //文字竖直排列后调整行高
    letter-spacing: 0.05rem; //竖直排序后文字之间距离
    color: #f54311 !important;
    font-size: 0.26rem;
    font-weight: 700;
    font-family: DINAlternate-Bold, sans-serif;
    text-align: center;


    a {
      text-decoration: none;
      pointer-events: none;
      color: #fff !important;
    }
  }

  .number-item {
    pointer-events: none;

    a {
      text-decoration: none;
      color: inherit;
    }
  }
}
</style>
